<template>
  <div class="progress-indicator py-2 mb-3 border-bottom">
    <div class="d-flex justify-content-between align-items-start position-relative">
      <div
        v-for="step in steps"
        :key="step.number"
        :class="getStepClass(step.number)"
        class="progress-step flex-fill text-center"
      >
        <div
          class="step-circle mx-auto d-flex align-items-center justify-content-center rounded-circle bg-white font-weight-bold position-relative"
        >
          <span v-if="step.number < currentStep" class="text-white">
            <font-awesome-icon icon="check" />
          </span>
          <span v-else>{{ step.number }}</span>
        </div>
        <div class="step-label mt-2 small">
          {{ step.label }}
        </div>
        <div
          v-if="step.number < 5"
          class="step-line position-absolute"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressIndicator',
  
  props: {
    currentStep: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  
  data() {
    return {
      steps: [
        { number: 1, label: this.$t('Webportal.Actions.InquiryWizard.Step1.Label') },
        { number: 2, label: this.$t('Webportal.Actions.InquiryWizard.Step2.Label') },
        { number: 3, label: this.$t('Webportal.Actions.InquiryWizard.Step3.Label') },
        { number: 4, label: this.$t('Webportal.Actions.InquiryWizard.Step4.Label') },
        { number: 5, label: this.$t('Webportal.Actions.InquiryWizard.Step5.Label') },
      ],
    };
  },
  
  methods: {
    getStepClass(stepNumber) {
      if (stepNumber < this.currentStep) {
        return 'progress-step--completed';
      } else if (stepNumber === this.currentStep) {
        return 'progress-step--active';
      }
      return 'progress-step--pending';
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-step {
  position: relative;
}

.step-circle {
  width: 48px;
  height: 48px;
  z-index: 2;
}

.step-line {
  top: 24px;
  left: 50%;
  width: 100%;
  height: 2px;
  z-index: 1;
  background-color: #e0e0e0;
}

.progress-step--completed {
  .step-circle {
    background-color: var(--success) !important;
    border: 2px solid var(--success);
  }

  .step-label {
    color: var(--primary);
    font-weight: 500;
  }
  
   .step-line {
    background-color: var(--success);
  }
}

.progress-step--active {
  .step-circle {
    background-color: var(--primary) !important;
    color: var(--white);
    border: 3px solid var(--primary);
    font-weight: 700;
    box-shadow: 0 0 0 4px var(--primary-20);
  }
  
  .step-label {
    color: black;
    font-weight: 600;
  }
}

.progress-step--pending {
  .step-circle {
    background-color: #f5f5f5 !important;
    color: #9e9e9e;
    border: 2px solid #e0e0e0;
  }
  
  .step-label {
    color: #9e9e9e;
  }
}

@media (max-width: 767px) {
  .step-circle {
    width: 36px !important;
    height: 36px !important;
    font-size: 0.875rem;
  }
  
  .step-label {
    font-size: 0.7rem !important;
  }
  
  .step-line {
    top: 18px !important;
  }
}
</style>
